<template>
	<bsh-modal
		titulo="Nova Entrega"
		:name="name">
		<template v-slot:default>
	        <entrega-form
				:dados="dados"
	        	:name="name"
	        	:errors="errors">
	        </entrega-form>
	    </template>
	    <template v-slot:footer>
        	<button
				ref="btnRequest"
        		type="button"
        		class="btn btn-primary"
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import Entrega from "./../../models/Entrega.js";
	export default {
		data(){
			return {
				dados: new Entrega(),
				name: 'create_entrega',
				errors: []
			}
		},
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.post(this.$url+'/api/adm/entregas/store', (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new Entrega()
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	}
		},
	}
</script>
